import printerLocations from './printerLocations'
import specialProductExpenses from './specialProductExpenses'
import taraName from './taraName'
import pointsSystem from './pointsSystem'
import actionGroups from './actionGroups'
import usedFAPriceLevels from './usedFAPriceLevels'

export default {
	printerLocations,
	specialProductExpenses,
	taraName,
	pointsSystem,
	actionGroups,
	usedFAPriceLevels
}
